export enum BOOKING_TYPE {
  BLOCKER = 'BLOCKER',
  AGENT = 'AGENT',
  TELEPHONE = 'TELEPHONE',
  ONLINE = 'ONLINE',
  TREATWELL = 'TREATWELL',
  RWG = 'RWG',
}
